<template>
  <CForm @submit.prevent="saveUser">
    <CCard>
      <CCardHeader>
        {{ $t(`${isUserCreate ? "New" : "Edit"} user`) }}
        <CButton class="mz-button v2-mz-btn mr-2" color="primary" type="submit">
          {{ $t("Save") }}
        </CButton>
      </CCardHeader>
      <CCardBody>
        <CCol col="12">
          <h5 v-if="isUserCreate">{{ $t("New user account") }}</h5>
          <div class="input-container gap-5">
            <CInput
              addInputClasses="mz-input"
              autocomplete="email"
              label="Email"
              type="email"
              v-model="user.email"
              required
              :disabled="!isAdministrator"
            />
            <CInput
              addInputClasses="mz-input"
              autocomplete="new-password"
              :label="$t('Password')"
              type="password"
              v-model="user.password"
              :required="isUserCreate"
              minLength="6"
            />
            <CInput
              addInputClasses="mz-input"
              :label="$t('Name')"
              v-model="user.firstname"
            />
            <CInput
              addInputClasses="mz-input"
              :label="$t('Last Name')"
              v-model="user.lastname"
            />
          </div>

          <div v-if="isAdministrator" class="mt-4">
            <h5>{{ $t("Role") }}</h5>
            <MzInputRadioGroup
              :checked.sync="user.role"
              :options="roles"
              inline
            />
          </div>
        </CCol>
      </CCardBody>
    </CCard>
  </CForm>
</template>

<script>
import { users } from "@/services/users";
import { ActiveUser } from "@/services/user";

export default {
  name: "user",
  data() {
    return {
      isUserCreate: false,
      isAdministrator: ActiveUser.isAdministrator(),
      id: this.$route.params.id || "me",
      roles: [],
      user: {},
    };
  },
  async mounted() {
    this.isUserCreate = this.id === "new";
    if (!this.isUserCreate) {
      this.fetchUser();
    }
    if (this.isAdministrator) {
      this.fetchRoles();
    }
  },
  methods: {
    async fetchRoles() {
      this.roles = await users.getRoles();
    },
    async fetchUser() {
      this.user = await users.getUser(this.id);
    },
    async saveUser() {
      if (this.isUserCreate) {
        const { id, detail } = await users.createUser(this.user);
        if (!id) {
          return alert(detail);
        }
        this.user = await users.editUser(id, this.user);
        alert(this.$t("User created successfully"), {
                action: {
                    text: this.$t('Close'),
                    icon: 'close',
                    onClick: (e, toastObject) => {
                        toastObject.goAway(0);
                    }
                }
            });
        await this.$router.push({ name: "Users" });
      } else {
        const data = await users.editUser(this.id, this.user);
        if (!data.id) {
          return alert(`Error: ${data.detail}`)
        }
        this.user = data;
        alert(this.$t("User saved successfully"), {
                action: {
                    text: this.$t('Close'),
                    icon: 'close',
                    onClick: (e, toastObject) => {
                        toastObject.goAway(0);
                    }
                }
            });
        await this.$router.push({ name: "Users" });
      }
      this.isUserCreate = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.input-container {
  width: 100%;
  display: grid;
  grid-template-columns: 1fr 1fr;
}
</style>
